import { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function ProgressiveProgressBar({ active = true, start = 0, end = 99 }) {
    const [count, setCount] = useState(active ? start : 100);
    const { t } = useTranslation();


    useEffect(() => {
        if (!active) {
            setCount(100);
            return;
        } else {
            setCount(start);
        }
    }, [active, start]);


    useEffect(() => {
        if (!active || count >= end) return;

        let delay = 1000;
        if (count >= 25 && count < 50) delay = 2000;
        else if (count >= 50 && count < 75) delay = 3000;
        else if (count >= 75 && count < 99) delay = 4000;

        const timer = setTimeout(() => {
            setCount((prev) => Math.min(prev + 1, end));
        }, delay);

        return () => clearTimeout(timer);
    }, [count, end, active]);

    return (
        <>
            <div className="custom-progress">
                <ProgressBar now={count} />
            </div>
            <div className="text">
                <h6>{count}%</h6>
            </div>
        </>
    );
}

export default ProgressiveProgressBar;
